export default {
  common: {
    login: "ログイン",
    loginRequired: "ログイン後ご利用ください。",
    logout: "ログアウト",
    signup: "会員登録",
    home: "ホーム",
    search: "検索",
    cancel: "キャンセル",
    confirm: "確認",
    save: "保存",
    delete: "削除",
    edit: "編集",
    welcome: "ようこそ",
    loading: "読み込み中...",
    error: "エラーが発生しました",
    noData: "データがありません",
    number: "番号",
    title: "タイトル",
    date: "日付",
    type: "種類",
    status: "状態",
    canceled: "キャンセル済み",
    approved: "承認済み",
    rejected: "拒否済み",
    waiting: "待機中",
    reset: "リセット",
    submit: "提出",
    success: "成功",
    failed: "失敗",
    amountMustBeGreaterThan0: "金額は0より大きい必要があります",
  },
  header: {
    announcement: "始まりました！",
    login: "ログイン",
    register: "会員登録",
    casino: "ライブカジノ",
    slotGame: "スロットゲーム",
    liveSports: "ライブスポーツ",
    cashIn: "入金",
    cashOut: "出金",
    needHelp: "お手伝いが必要ですか",
    honorific: "様",
    chip: "チップ",
    point: "ポイント",
    partnerPage: "パートナーページ",
  },
  slider: {
    casino: {
      subtitle: "SHOGUN LIVE CASINO",
      title1: "ライブカジノ",
      title2: "すべてのプレイヤーの満足を保証します",
    },
    slot: {
      subtitle: "SHOGUN SLOT GAME",
      title1: "ライブスロット",
      title2: "すべてのプレイヤーの満足を保証します",
    },
    sports: {
      subtitle: "SHOGUN SPORTS",
      title1: "ライブスポーツ",
      title2: "すべてのプレイヤーの満足を保証します",
    },
  },
  homePage: {
    casino: {
      title: "ライブカジノ",
      subtitle: "SHOGUN CASINO",
    },
    slot: {
      title: "スロット",
      subtitle: "SHOGUN SLOT",
    },
  },
  gameList: {
    showAll: "全て表示",
    underMaintenance: "点検中です。",
  },
  board: {
    faq: {
      subtitle: "よくある質問",
      title: "FAQ",
      viewMore: "FAQをもっと見る",
      items: [
        {
          id: 1,
          title: "'SHOGUN'はどのような会社ですか？",
          content: "'SHOGUN'はオンラインカジノとモバイルカジノサービスを提供するグローバルゲームプラットフォームです。24時間365日運用しており、100以上の異なるカジノゲームを提供します。"
        },
        {
          id: 2,
          title: "ウェブサイトは安全ですか？",
          content: "はい、SHOGUNは最新のセキュリティシステムを導入して、会員の個人情報と資産を保護します。すべての取引は暗号化され、公正なゲーム環境を確保するために定期的な監査を行っています。"
        },
        {
          id: 3,
          title: "ゲームはたくさんありますか？",
          content: "はい、SHOGUNは100以上の異なるゲームを提供します。ライブカジノ、スロットゲーム、ミニゲームなど、さまざまなジャンルを楽しむことができます。特にプログレッシブジャックポットゲームでは大きな賞金を獲得することができます。"
        },
        {
          id: 4,
          title: "Q4. どのようにして預金と引き出しを行いますか？",
          content: "SHOGUNは様々な預金と引き出し方法をサポートします。銀行振込、暗号通貨（USDT）、そして便利な方法を使用できます。預金は5-10分以内に処理されます。"
        }
      ],
    },
    notice: {
      subtitle: "お知らせ",
      title: "最新のお知らせ",
      viewMore: "お知らせをもっと見る",
    },
  },
  footer: {
    ourPartners: "私たちのパートナー",
    copyright: "著作権 2024 SHOGUN. 全著作権所有",
    casino: "ライブカジノ",
    slotGame: "スロットゲームノ",
    miniGame: "ミニゲーム",
  },
  auth: {
    login: "ログイン",
    register: "会員登録",
    username: "ユーザー名",
    password: "パスワード",
    passwordConfirm: "パスワード確認",
    passwordMismatch: "パスワードが一致しません",
    rememberPassword: "パスワードを記憶する",
    captcha: "キャプチャテキストを入力してください",
    referrer: "紹介コード",
    phone: "電話番号",
    nameBank: "銀行名",
    numberBank: "口座番号",
    userBank: "口座名義人",
    loginFailed: "ログインに失敗しました。",
    registerFailed: "会員登録に失敗しました。",
  },
  maintenance: {
    title: "まもなく戻ります！",
    message: "システムメンテナンス中です。ご不便をおかけして申し訳ありません。",
  },
  homePopup: {
    selectList: "リストを選択",
    deposit: "入金",
    withdrawal: "出金",
    bankingHistory: "銀行取引履歴",
    pointToChip: "ポイントをチップに変換",
    notice: "お知らせ",
    inquiry: "お問い合わせ",
    myInfo: "マイ情報",
    betHistory: "ベット履歴",
    faq: "よくある質問",
  },
  betting: {
    name: "ベット名",
    game: "ゲーム",
    type: "タイプ",
    amount: "金額",
    date: "日付",
    status: {
      win: "勝利",
      lose: "敗北",
      bet: "ベット",
    },
  },
  deposit: {
    notice: "入金情報を正確にご確認ください",
    info: "入金は5-10分以内に処理されます",
    currentBalance: "現在の残高",
    amount: "入金額",
    usdtAmount: "USDT入金額",
    requestAccount: "入金口座のリクエスト",
    requestUsdtAddress1: "ポリゴンUSDTアドレス",
    requestUsdtAddress2: "tronUSDTアドレス",
    myWallet: "マイウォレット",
    bottomNotice:
      "ご不明な点がございましたら、カスタマーサービスまでお問い合わせください",
    title: "入金",
    normalDeposit: "一般入金",
    usdtDeposit: "USDT入金",
  },
  withdrawal: {
    notice: "出金情報を正確にご確認ください",
    currentBalance: "現在の残高",
    walletAddress: "ウォレットアドレス",
    amount: "出金額",
    usdtAmount: "USDT出金額",
    password: "出金パスワード",
    myWallet: "マイウォレット",
    title: "出金",
    normalWithdrawal: "一般出金",
    usdtWithdrawal: "USDT出金",
  },
  banking: {
    bankAccountRequired: "銀行口座情報が必要です",
  },
  bankinghistory: {
    beforeBalance: "入金前残高",
    requestAmount: "申請金額",
    afterBalance: "入金後残高",
  },
  profile: {
    username: "ユーザー名",
    balance: "残高",
    point: "ポイント",
    changePassword: "パスワード変更",
    currentPassword: "現在のパスワード",
    newPassword: "新しいパスワード",
    confirmPassword: "パスワード確認",
    passwordChanged: "パスワードが正常に変更されました",
    passwordMismatch: "パスワードが一致しません",
    invalidPassword: "現在のパスワードが正しくありません",
  },
  notice: {
    unread: "未確認",
    read: "確認済み",
  },
  inquiry: {
    title: "お問い合わせタイトル",
    select: "お問い合わせ種類を選択",
    writer: "作成者",
    placeholder: "お問い合わせ内容を入力してください（最大100文字）",
    types: {
      deposit: "入金について",
      withdrawal: "出金について",
      account: "入金口座のリクエスト",
      other: "その他",
    },
    question: "質問",
    answer: "回答",
    status: "状態",
    pending: "回答待ち",
    inProgress: "回答中",
    completed: "回答完了",
    unknown: "不明",
    empty: "問い合わせがありません",
    reply: "返信",
    send: "送信",
    note: "回答待ち",
    showMore: "もっと見る",
    showLess: "閉じる",
    newInquiry: "新規問い合わせ",
    delete: "削除",
    deleteConfirmation: "本当に削除しますか？",
  },
  point: {
    currentBalance: "現在のポイント",
    amount: "換金額",
    enterAmount: "金額を入力してください",
    password: "パスワード",
    enterPassword: "パスワードを入力してください",
    convert: "換金する",
    invalidAmount: "無効な金額です",
    convertSuccess: "ポイントの換金が完了しました",
  },
}; 